import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import NewArrival from '../Home/NewArrival';
import { RiFacebookFill, RiInstagramLine, RiTwitterLine } from "react-icons/ri";
import { toast } from 'react-hot-toast';
import "./styles.css"

import { useProducts } from '../../Context/ProductProvider';
import { actionTypes } from '../../Context/actionTypes';


const SingleProduct = () => {

    // ============ Image Mag=============

    function ImageMagnifier({
        src,
        width,
        height,
        magnifierHeight = 200,
        magnifieWidth = 200,
        zoomLevel = 1.5
    }: {
        src: string;
        width?: string;
        height?: string;
        magnifierHeight?: number;
        magnifieWidth?: number;
        zoomLevel?: number;
    }) {
        const [[x, y], setXY] = useState([0, 0]);
        const [[imgWidth, imgHeight], setSize] = useState([0, 0]);
        const [showMagnifier, setShowMagnifier] = useState(false);
        return (
            <div
                style={{
                    position: "relative",
                    height: height,
                    width: width
                }}
            >
                <img
                    src={src}
                    style={{ height: 500, width: "100%", objectFit: "fill", }}
                    onMouseEnter={(e) => {
                        // update image size and turn-on magnifier
                        const elem = e.currentTarget;
                        const { width, height } = elem.getBoundingClientRect();
                        setSize([width, height]);
                        setShowMagnifier(true);
                    }}
                    onMouseMove={(e) => {
                        // update cursor position
                        const elem = e.currentTarget;
                        const { top, left } = elem.getBoundingClientRect();

                        // calculate cursor position on the image
                        const x = e.pageX - left - window.pageXOffset;
                        const y = e.pageY - top - window.pageYOffset;
                        setXY([x, y]);
                    }}
                    onMouseLeave={() => {
                        // close magnifier
                        setShowMagnifier(false);
                    }}
                    alt={"img"}
                />

                <div
                    style={{
                        display: showMagnifier ? "" : "none",
                        position: "absolute",

                        // prevent maginier blocks the mousemove event of img
                        pointerEvents: "none",
                        // set size of magnifier
                        height: `${magnifierHeight}px`,
                        width: `${magnifieWidth}px`,
                        // move element center to cursor pos
                        top: `${y - magnifierHeight / 2}px`,
                        left: `${x - magnifieWidth / 2}px`,
                        opacity: "1", // reduce opacity so you can verify position
                        border: "5px solid lightgray",
                        backgroundColor: "white",
                        backgroundImage: `url('${src}')`,
                        backgroundRepeat: "no-repeat",

                        //calculate zoomed image size
                        backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel
                            }px`,

                        //calculete position of zoomed image.
                        backgroundPositionX: `${-x * zoomLevel + magnifieWidth / 2}px`,
                        backgroundPositionY: `${-y * zoomLevel + magnifierHeight / 2}px`
                    }}
                ></div>
            </div>
        );
    }

    // ============ Image Mag=============

    const navigate = useNavigate()
    const redirectToShopProducts = (shopId, shopName) => {
        navigate(`/shop-products/${shopId}/${shopName}`);
    };

    const { state: { cart }, dispatch } = useProducts();
    const [productDetails, setProductDetails] = useState({});
    const { id } = useParams()
    useEffect(() => {
        fetch(`${process.env.REACT_APP_SECRET_API}/product/${id}?include=shop`, {
            method: "GET",
            headers: {
                'content-type': "application/json",
                'authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => res.json())
            .then(data => {
                // console.log(data.data)
                setProductDetails(data?.data)
            })
    }, [id])
    // console.log(productDetails)


    const redirectToCart = () => {
        dispatch({ type: actionTypes.ADD_TO_CARD, payload: productDetails })
        navigate("/cart")
        toast.success('added cart.');
    }
    const removeToCart = () => {
        dispatch({ type: actionTypes.REMOVE_FROM_CART, payload: productDetails })

        toast.success('Remove from cart.');
    }

    // console.log(productDetails)
    productDetails.quantity = 1
    // console.log("new product quantity:", productDetails)
    const { name, offer_price, price, status, shop, stock } = productDetails;
    console.log(productDetails)

    const [mainImgSrc, setMainImgSrc] = useState(productDetails?.gallery?.[0]?.original_url);
    console.log("img", productDetails?.gallery?.[0]?.original_url)
    const handleImgClick = (e) => {
        setMainImgSrc(e.target.src);
    };

    return (
        <div>
            <div class="container pt-4 pb-6 grid lg:grid-cols-2 gap-6">
                {/* <!-- product image --> */}
                <div>
                    <div className='grid grid-cols-1 text-center gap-4 mt-4' >
                        <div className='relative'>
                            {stock === 0 && (
                                <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center z-50 bg-black bg-opacity-50">
                                    <span className="text-white text-2xl font-semibold z-20">Out of stock</span>
                                </div>
                            )}
                            <div>
                                <ImageMagnifier src={mainImgSrc ? mainImgSrc : productDetails?.gallery?.[0]?.original_url} />
                            </div>

                        </div>
                    </div>
                    <div className="grid grid-cols-5 gap-4 mt-4">
                        {productDetails?.gallery?.map(photo => (
                            <div>
                                <img
                                    src={photo?.original_url}
                                    className={`single-img w-full cursor-pointer border ${mainImgSrc === photo.original_url ? 'border-primary' : ''}`}
                                    alt=""
                                    onClick={handleImgClick}
                                />

                            </div>
                        ))}
                    </div>
                </div>
                {/* <!-- product image end --> */}
                {/* <!-- product content --> */}
                <div>
                    <h2 class="md:text-3xl text-2xl font-medium uppercase mb-2">{name}</h2>
                    <div className="flex items-center mb-4">
                        <div className="flex gap-1 text-sm text-yellow-400">
                            Best Product
                        </div>
                        {/* <div className="text-xs text-gray-500 ml-3">(150 Reviews)</div> */}
                    </div>
                    <div class="space-y-2">
                        <p class="text-gray-800 font-semibold space-x-2">
                            <span>Availability: </span>
                            <span class="text-green-600">{stock === 0 ? "out of stock" : status}</span>
                        </p>
                        <p class="space-x-2">
                            <span className="text-gray-800 font-semibold">Shop: </span>
                            <span className="text-gray-600 text-xs"><button className='btn btn-sm text-xs' onClick={() => redirectToShopProducts(shop?.id, shop?.name)}>{shop?.name}</button></span>
                        </p>
                        <p class="space-x-2">
                            <span class="text-gray-800 font-semibold">SKU: </span>
                            <span class="text-gray-600">BE45VGRT</span>
                        </p>
                    </div>
                    <div className="flex items-baseline mb-1 space-x-2 font-roboto mt-4">
                        <p className="text-xl text-primary font-semibold"><span className='text-[20px] font-bold'>৳</span>{offer_price ? offer_price : price}.00</p>
                        {/* <p className="text-base text-gray-400 line-through"><span className='text-[15px] font-bold'>৳</span>{price}.00</p> */}
                    </div>

                    <p className="mt-4 text-gray-600">{productDetails?.short_description ? productDetails?.short_description : <p className="text-red-500 text-[18px]">No Description</p>}</p>
                    {/* <!-- size --> */}
                    <div class="mt-4">
                        <h3 class="text-base text-gray-800 mb-1">Size</h3>
                        <div class="flex items-center gap-2">
                            {/* <!-- single size --> */}
                            <div class="size-selector">
                                <input type="radio" name="size" class="hidden" id="size-xs" />
                                <label for="size-xs"
                                    class="text-xs border border-gray-200 rounded-sm h-6 w-6 flex items-center justify-center cursor-pointer shadow-sm text-gray-600">
                                    XS
                                </label>
                            </div>
                            {/* <!-- single size end --> */}
                            {/* <!-- single size --> */}
                            <div class="size-selector">
                                <input type="radio" name="size" class="hidden" id="size-s" />
                                <label for="size-s"
                                    class="text-xs border border-gray-200 rounded-sm h-6 w-6 flex items-center justify-center cursor-pointer shadow-sm text-gray-600">
                                    S
                                </label>
                            </div>
                            {/* <!-- single size end --> */}
                            {/* <!-- single size --> */}
                            <div class="size-selector">
                                <input type="radio" name="size" class="hidden" id="size-m" checked />
                                <label for="size-m"
                                    class="text-xs border border-gray-200 rounded-sm h-6 w-6 flex items-center justify-center cursor-pointer shadow-sm text-gray-600">
                                    M
                                </label>
                            </div>
                            {/* <!-- single size end --> */}
                            {/* <!-- single size --> */}
                            <div class="size-selector">
                                <input type="radio" name="size" class="hidden" id="size-l" />
                                <label for="size-l"
                                    class="text-xs border border-gray-200 rounded-sm h-6 w-6 flex items-center justify-center cursor-pointer shadow-sm text-gray-600">
                                    L
                                </label>
                            </div>
                            {/* <!-- single size end --> */}
                            {/* <!-- single size --> */}
                            <div class="size-selector">
                                <input type="radio" name="size" class="hidden" id="size-xl" />
                                <label for="size-xl"
                                    class="text-xs border border-gray-200 rounded-sm h-6 w-6 flex items-center justify-center cursor-pointer shadow-sm text-gray-600">
                                    XL
                                </label>
                            </div>
                            {/* <!-- single size end --> */}
                        </div>
                    </div>
                    {/* <!-- size end --> */}
                    {/* <!-- color --> */}
                    <div className="mt-6 gap-3 border-b border-gray-200 pb-5 pt-12">
                        {/* <button onClick={redirectToCart} className="rounded-none border border-primary text-white px-8 py-4 text-center font-medium uppercase flex items-center justify-center bg-gradient-to-l from-primary to-[#52a3eb] gap-2 hover:from-[#52a3eb] hover:to-primary transition">
                            <RiShoppingBagFill /> Add to cart
                        </button> */}
                        {
                            cart?.some(cartProduct => cartProduct?.id === productDetails?.id) ? (
                                <button onClick={removeToCart} className="block w-full mt-4 py-2 text-center text-white bg-gradient-to-l from-red-500 to-[#52a3eb] hover:from-[red] hover:to-primary ease-in-out delay-150 duration-300 transition" disabled={stock === 0}>
                                    Remove From Cart
                                </button>
                            ) : (
                                <button onClick={redirectToCart} className={`block w-full mt-4 py-2 text-center text-white bg-gradient-to-l from-primary to-[#52a3eb] hover:from-[#52a3eb] hover:to-primary ease-in-out delay-150 duration-300 transition ${stock === 0 ? 'disabled:cursor-not-allowed' : ''}`} disabled={stock === 0}>
                                    {stock === 0 ? 'Out of Stock' : 'Add to Cart'}
                                </button>
                            )
                        }

                    </div>
                    {/* <!-- color end --> */}
                    {/* <!-- quantity --> */}

                    {/* <!-- color end --> */}
                    {/* <!-- add to cart button --> */}

                    {/* <!-- add to cart button end --> */}

                    {/* <!-- product share icons --> */}
                    <div class="flex space-x-3 mt-4">
                        <Link to="/" class="text-gray-400 hover:text-gray-500 h-8 w-8 rounded-full border border-gray-300 flex items-center justify-center">
                            <RiFacebookFill />
                        </Link>
                        <Link to="/"
                            class="text-gray-400 hover:text-gray-500 h-8 w-8 rounded-full border border-gray-300 flex items-center justify-center">
                            <RiInstagramLine />
                        </Link>
                        <Link to="/"
                            class="text-gray-400 hover:text-gray-500 h-8 w-8 rounded-full border border-gray-300 flex items-center justify-center">
                            <RiTwitterLine />
                        </Link>
                    </div>
                    {/* <!-- product share icons end --> */}
                </div>
                {/* <!-- product content end --> */}
            </div>
            {/* <!-- product view end --> */}

            {/* <!-- product details and review --> */}
            <div class="container pb-16">
                {/* <!-- detail buttons --> */}
                <h3 class="border-b border-gray-200 font-roboto text-gray-800 pb-3 font-medium">
                    Product Details
                </h3>
                {/* <!-- details button end --> */}

                {/* <!-- details content --> */}
                <div class="lg:w-4/5 xl:w-3/5 pt-6">
                    <div class="space-y-3 text-gray-600">
                        <p className="mt-4 text-gray-600">{productDetails?.long_description ? productDetails.long_description : <p className="text-red-500 text-[18px]">No Description</p>}</p>
                    </div>

                    {/* <table class="table-auto border-collapse w-full text-left text-gray-600 text-sm mt-6">
                        <tr>
                            <th class="py-2 px-4 border border-gray-300 w-40 font-medium">Color</th>
                            <td class="py-2 px-4 border border-gray-300">Black, Brown, Red</td>
                        </tr>
                        <tr>
                            <th class="py-2 px-4 border border-gray-300 w-40 font-medium">Material</th>
                            <td class="py-2 px-4 border border-gray-300">Artificial Leather</td>
                        </tr>
                        <tr>
                            <th class="py-2 px-4 border border-gray-300 w-40 font-medium">Weight</th>
                            <td class="py-2 px-4 border border-gray-300">{weight}</td>
                        </tr>
                    </table> */}

                </div>

            </div>
            <NewArrival></NewArrival>
            {/* <TrandingProducts></TrandingProducts> */}
        </div>
    );
};

export default SingleProduct;